<script setup>
defineProps({
  placeholder: {
    type: String,
    default: 'Search',
  },
});
const { search } = inject('searchState');
</script>

<template>
  <label for="search" class="relative flex h-fit">
    <div class="pointer-events-none absolute inset-y-0 left-2 flex items-center pl-3">
      <svg
        class="size-4 text-gray-300 dark:text-gray-300"
        aria-hidden="true"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
        />
      </svg>
    </div>
    <div class="custom-gradient w-full rounded-xl">
      <input
        id="search"
        v-model="search"
        type="search"
        class="block w-full rounded-lg bg-transparent px-10 py-2 text-lg outline-none ring-0 placeholder:text-gray-300 dark:bg-gray-300/20 dark:text-white"
        :placeholder="placeholder"
        required
      />
    </div>
  </label>
</template>
